import { TIMER_CONFIG } from '../constants/game'
import { assetsImageLoader, seconds2StringFormat } from '../utils/funtions'
import { TimerData } from '../utils/TimerData'

export default class Timer {
  /** @type Phaser.GameObjects.Image */
  icon
  /** @type Phaser.GameObjects.Text */
  text
  /** @type Phaser.GameObjects.Image */
  container
  /** @type Phaser.Time.TimerEvent */
  timerEvent

  /**
   * @type {{
   * context: Phaser.Scene,
   * data: TimerData
   * }}
   **/
  config = {}

  /**
   * @param {Phaser.Scene} context
   * @param {TimerData} data
   */
  constructor(context, data) {
    this.config.context = context
    this.config.data = new TimerData(data)
  }

  preload() {

    assetsImageLoader(
      {
        bg: TIMER_CONFIG.bgSrc,
        icon: TIMER_CONFIG.iconSrc,
      },
      'timer-',
      this.config.context
    );

  }

  create() {
    this.ID_CAM_FILTER = this.config.context.cameras.getCamera('minimap').id
    this.MEDIA_TYPE = this.config.context.data.get('mediaType')
    this.config.context.data.set('TIME', this.config.data.initialValue)
    this.makeTimer()
    this.makeTimerEvent()
  }

  upload() {
    try {
      const CURRENT_TIME = this.config.context.data.get('TIME')
      const seconds = seconds2StringFormat(CURRENT_TIME)
      this.text.setText(TIMER_CONFIG.text.replace('$', seconds))
    } catch (error) {
      console.info(error)
    }
  }

  makeTimer() {
    this.container = this.config.context.add
      .image(
        TIMER_CONFIG.posX[this.MEDIA_TYPE](
          this.config.context.game.config.width
        ),
        TIMER_CONFIG.posY[this.MEDIA_TYPE](
          this.config.context.game.config.height, this.config.context.game.config.width
        ),
        'timer-bg'
      )
      .setOrigin(0, 0)
      .setScrollFactor(0)
      .setDepth(TIMER_CONFIG.depth);
    this.container.displayMaxWidth = TIMER_CONFIG.displayWidth[this.MEDIA_TYPE]

    this.container.cameraFilter = this.ID_CAM_FILTER

    this.icon = this.config.context.add
      .image(
        this.container.x + 10,
        this.container.y + this.container.height / 2,
        'timer-icon'
      )
      .setOrigin(0, 0.5)
      .setScrollFactor(0)
      .setDepth(TIMER_CONFIG.depth + 1)

    this.icon.cameraFilter = this.ID_CAM_FILTER;

    this.text = this.config.context.add.text(
        this.container.x + 30,
        this.container.y + this.container.height / 2,
        TIMER_CONFIG.text,
        TIMER_CONFIG.style[this.MEDIA_TYPE]
      )
      .setOrigin(0, 0.5)
      .setScrollFactor(0)
      .setResolution(2)
      .setDepth(TIMER_CONFIG.depth+1)

    this.text.cameraFilter = this.ID_CAM_FILTER
  }

  makeTimerEvent() {
    this.timerEvent = this.config.context.time.addEvent({
      delay: this.config.data.frequency,
      callback: this.ticTimer,
      callbackScope: this,
      loop: true,
    })
  }

  ticTimer() {
    const currentTime = this.config.context.data.get('TIME')
    const isOverLimit =
      this.config.data.incrementFactor > 0
        ? currentTime >= this.config.data.limitTime
        : currentTime <= this.config.data.limitTime
    if (isOverLimit) {
      this.config.context.data.set('TIME', this.config.data.limitTime)
      this.config.data.timeOffHandler()
    } else {
      this.config.context.data.set(
        'TIME',
        currentTime + this.config.data.incrementFactor
      )
    }
  }

  stop(){
    this.timerEvent.remove();
  }
}
